/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Portal_LinkInputs */



/**
* | output |
* | --- |
* | "Signing in as a client? Open your portal" |
*
* @param {Signin_Portal_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_portal_link = /** @type {((inputs?: Signin_Portal_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Portal_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Signing in as a client? Open your portal")
});